import {
  ActionPayload,
  ActionType,
  TriggerType,
} from 'src/interfaces/action.interface';

export const triggerTypes = [
  {
    label: 'Function Call',
    value: TriggerType.FunctionCall,
    description: 'Let Fluents.ai decide when to trigger this action',
  },
  {
    label: 'Phrase Based',
    value: TriggerType.PhraseBased,
    description: 'This action will trigger based on a bot-spoken phrase.',
  },
];

export const newAction: ActionPayload = {
  type: null as unknown as ActionType,
  config: {},
  action_trigger: {
    type: TriggerType.FunctionCall,
    config: {},
  },
  label: '',
};

export const actionConfig: {
  [key: string]: {
    icon: string;
    iconStyling: string;
    label: string;
    modalLabel: string;
    description: string;
    disabled?: boolean;
  };
} = {
  [ActionType.EndConversation]: {
    icon: 'end-conversation.svg',
    iconStyling: 'w-[22.4px] h-[8.7px]',
    label: 'End Conversation',
    modalLabel: 'End Conversation',
    description: 'Configure when the agent should end the call.',
  },
  [ActionType.TransferCall]: {
    icon: 'transfer-calls.svg',
    iconStyling: 'w-[24px] h-[24px]',
    label: 'Transfer Call',
    modalLabel: 'Transfer Calls',
    description:
      'Configure when the agent should transfer the call to another number.',
  },
  [ActionType.SetHold]: {
    icon: 'place-on-hold.svg',
    iconStyling: 'w-[12px] h-[14px]',
    label: 'Set Hold',
    modalLabel: 'Place on Hold',
    description:
      'This action places an active call on hold, pausing the conversation so neither party can hear each other until the call is resumed.',
    disabled: true,
  },
  [ActionType.AddToConference]: {
    icon: 'add-multiple-participants.svg',
    iconStyling: 'w-[21px] h-[20px]',
    label: 'Add To Conference',
    modalLabel: 'Add multiple participants',
    description:
      'This action helps add multiple participants to a call and merges individual calls into a single conference, allowing group communication.',
    disabled: true,
  },
  [ActionType.DTMF]: {
    icon: 'dtmf.svg',
    iconStyling: 'w-[25px] h-[25px]',
    label: 'DTMF',
    modalLabel: 'Use DTMF (Dual Tone Multi-frequency)',
    description: 'Allow the bot to send keypresses during a call.',
  },
  [ActionType.External]: {
    icon: 'custom-external-actions.svg',
    iconStyling: 'w-[18.12px] h-[18px]',
    label: 'External',
    modalLabel: 'Custom Input',
    description: 'Trigger your own APIs during a call.',
  },
  [ActionType.WarmTransfer]: {
    icon: 'add-multiple-participants.svg',
    iconStyling: 'w-[21px] h-[20px]',
    label: 'Warm Transfer Call',
    modalLabel: 'Warm Transfer Calls',
    description:
      'Have the agent contact the transfer recipient before transferring the call',
  },
};
